import defaultFavicon from '@/assets/images/favicon.ico'
import type { PlatformUser } from '@/stores/auth'
import { useAuthStore, useUser } from '@/stores/authStore'
import { useEffect } from 'react'

/**
 * Sets the browser favicon from the current org's brand_mark.
 * Falls back to the default Bytebeam favicon when no brand_mark is set.
 */
export function useDynamicFavicon() {
	const user = useUser() as PlatformUser | null
	const currentOrgId = useAuthStore(state => state.currentOrganizationId)

	useEffect(() => {
		const org = currentOrgId ? user?.organizations?.find(o => o.id === currentOrgId) : null
		const brandMark = org?.frontend_settings?.branding?.brand_mark

		const link: HTMLLinkElement = document.querySelector("link[rel~='icon']") || document.createElement('link')
		link.rel = 'icon'
		link.href = brandMark || defaultFavicon

		if (!document.head.contains(link)) {
			document.head.appendChild(link)
		}
	}, [user, currentOrgId])
}
